import { CLEAN, PREQUOTE } from "@/constants/common.constants";
export default function () {
  return {
    form: {
      industries: [],
      occupations: [],
      sections: [],
      repeatingQuestionSetIndex: 0,
      propertyDetailsFormVisibility: false,
      isLNErrorMessageEnabled: true,
      showAddressFinderManuallyForm: false,
      manualAddressData: {},
      originalQuickQuotePropertyData: null,
    },
    factFind: {},
    products: null,
    buildingsAd: false,
    contentsAd: false,
    productId: null,
    branchNumber: null,
    callChannel: null,
    qsId: null,
    maxCommissionSacrifice: null,
    quoteResponse: {},
    quoteStatus: PREQUOTE,
    lastQuoteErrorType: null,
    lastClientErrorResponse: null,
    token: sessionStorage.getItem("token"),
    userId: sessionStorage.getItem("userId"),
    quoteAccessId: sessionStorage.getItem("quoteAccessId"),
    lexisNexisResponse: {},
    coverAnswers: [],
    commissionSacrifice: 0,
    userReference: null,
    isDrawerCustomiseCoverPopulatedFromApi: false,
    ncdBuildingsState: CLEAN,
    ncdContentsState: CLEAN,
    lastEditedSectionTitle: null,
    overlay: false,
    isExpired: false,
    contactInfo: null,
    productTransferInProgress: false,
    isQuickQuote: false,
    needRefreshQuote: false,
    isAnnualRequote: false,
    homeEligibility: [
      {
        Value: "False",
        InterfaceKey: "HomeEligibility",
      },
    ],
    quoteRequestIdAfterRetrieve: null,
    selectedQuoteIds: [],
    capabilities: null,
    isShowSaveAndExitDialog: false,
    isShowGlobalSaveAndExitDialog: false,
    isShowQuoteExpiredDialog: false,
    showAppOverlay: false,
    questionMap: {},
    // flag to mark when users is coming into the system for the first time and is redirecting them to the last step they edited
    // (Only using for d2c landlord journey for now)
    restoringLastStep: true,
    isGA4EventToBeFired: false,
    insuredParty: null,
    companyName: null,
    hasResetQuickQuotePropertyData: false,
    quoteExcessConfiguration: null,
    quoteAdditionalData: {},
    isOriginalQuoteExpired: false,
    currentRefObserverForm: null,
    exitDestination: null,
    currentPath: null,
  };
}
